.inlineDl {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.25rem 0.5rem;
}

.inlineDl dt {
  font-weight: bold;
}

.inlineDl dd {
  margin: 0;
}
